export default function () {
  const widgetName = 'staticManagedSponsors';
  const widgetOpts = staticManagedSponsorsOpts;

  const wrapContainerClass = 'sponsors-wrap-container';

  const enableHeading = true;
  const headingTag = 'h2';
  const headingTitle = 'Premium Sponsors';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length <= 0) {
        $(`${wrapContainerClass}`).remove();
      } else {
        modifyLinkBehavior(widgetData);
      }
    },
  });

  // *********************************************************
  // Function Helper
  function modifyLinkBehavior(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $sponsor = $(this);

      $sponsor.find('.card-content').remove();
      $sponsor.removeAttr('target');
      $sponsor.attr('title', widgetData[x].Title);

      if (widgetData[x].URL == null) {
        $sponsor.removeAttr('href');
      }
    });

    $(`#${widgetName}`)
      .wrap(`<div class="${wrapContainerClass}"></div>`)
      .wrap('<div class="inner-container"></div>');

    if (enableHeading) {
      $(`.${wrapContainerClass} .inner-container`).prepend(
        `<${headingTag} class="static-sponsors-title">${headingTitle}</${headingTag}>`,
      );
    }
  }
}
